module.exports = __webpack_public_path__ + "media/images/game_icon/zh-tw/AB1030-84050d8209ea3d9afeeed1395eb9ee86.png";